import api from '@/api/microSite'

const state = {
  siteData: {},
  // some runtime value
  pagePathPrefix: '',
  isEditMode: false,
  isPreview: false,
  isMobile: false,
  languageCode: 'zh-cn',
  sitePages: [],
  currentPage: {},
  currentPageType: 'pc_cn',
  pageModuleRefs: {},
  themes: {},
  companyInfo: {},
  jobIds: null
}

const actions = {
  getSiteDataById ({ state }, { id, type }) {
    if (process.env.NODE_ENV !== 'production') {
      if (type === 'local') {
        return state.siteData[id] || {
          mobile: {
            en: {},
            cn: {}
          },
          pc: {
            en: {},
            cn: {}
          }
        }
      }
    }
    return api.getSiteDataById(id, type)
  },

  updateSiteData ({ commit, state }, { siteData, type }) {
    if (process.env.NODE_ENV !== 'production') {
      if (type === 'local') {
        commit('SAVE_CONFIG_LOCAL', siteData)
        return 'success'
      }
    }
    return api.updateSiteData({
      siteData,
      isMobile: state.isMobile,
      languageCode: state.languageCode,
      jobIds: state.jobIds
    }, type)
  },

  getCompanyTree ({ commit }) {
    return api.getCompanyTree()
  },

  getCompanyJob ({ commit }, companyIds) {
    return api.getCompanyJob(companyIds)
  },

  getJob ({ commit }, params) {
    return api.getJob(params)
  },

  getMicrositeFormSubmitData ({ commit }, params) {
    return api.getMicrositeFormSubmitData(params)
  },

  submitMicrositeFormData ({ commit }, params) {
    return api.submitMicrositeFormData(params)
  },

  updateMicrositeFormData ({ commit }, params) {
    return api.updateMicrositeFormData(params)
  },

  createMicrositeFormExportTask ({ commit }, params) {
    return api.createMicrositeFormExportTask(params)
  },

  getMicrositeFormExportData ({ commit }, params) {
    return api.getMicrositeFormExportData(params)
  },

  resetRuntimeData ({ commit }) {
    commit('SET_PAGE_PATH_PREFIX', null)
    commit('SET_EDIT_MODE', false)
    commit('SET_SITE_PAGES', [])
    commit('SET_CURRENT_PAGE', null)
    commit('SET_PAGE_MODULE_REFS', null)
  },

  setPagePathPrefix ({ commit }, prefix) {
    commit('SET_PAGE_PATH_PREFIX', prefix)
  },

  setEditMode ({ commit }, isEditMode) {
    commit('SET_EDIT_MODE', isEditMode)
  },

  setPreview ({ commit }, isPreview) {
    commit('SET_PREVIEW', isPreview)
  },

  setMobile ({ commit }, isMobile) {
    commit('SET_MOBILE', isMobile)
  },

  setLanguageCode ({ commit }, languageCode) {
    commit('SET_LANGUAGE_CODE', languageCode)
  },

  setSitePages ({ commit }, pages) {
    commit('SET_SITE_PAGES', pages)
  },

  setCurrentPage ({ commit }, currentPage) {
    commit('SET_CURRENT_PAGE', currentPage)
  },

  setCurrentPageType ({ commit }, currentPageType) {
    commit('SET_CURRENT_PAGE_TYPE', currentPageType)
  },

  setPageModuleRefs ({ commit }, refs) {
    commit('SET_PAGE_MODULE_REFS', refs)
  },

  setThemes ({ commit }, themes) {
    commit('SET_THEMES', themes)
  },

  setJobIds ({ commit }, jobIds) {
    commit('SET_JOB_IDS', jobIds)
  },

  setCompanyBasicInfo ({ commit }, companyInfo) {
    commit('SET_COMPANY_INFO', companyInfo)
  }
}

const mutations = {
  SAVE_CONFIG_LOCAL (state, siteData) {
    const id = siteData.id
    const data = {
      mobile: {
        en: siteData,
        cn: siteData
      },
      pc: {
        en: siteData,
        cn: siteData
      }
    }
    state.siteData[id] = data
  },
  SET_PAGE_PATH_PREFIX (state, prefix) {
    state.pagePathPrefix = prefix
  },
  SET_EDIT_MODE (state, isEditMode) {
    state.isEditMode = isEditMode
  },
  SET_PREVIEW (state, isPreview) {
    state.isPreview = isPreview
  },
  SET_MOBILE (state, isMobile) {
    state.isMobile = isMobile
  },
  SET_LANGUAGE_CODE (state, languageCode) {
    state.languageCode = languageCode
  },
  SET_SITE_PAGES (state, pages) {
    state.sitePages = pages
  },
  SET_CURRENT_PAGE (state, currentPage) {
    state.currentPage = currentPage
  },
  SET_CURRENT_PAGE_TYPE (state, currentPageType) {
    state.currentPageType = currentPageType
  },
  SET_PAGE_MODULE_REFS (state, pageModuleRefs) {
    state.pageModuleRefs = pageModuleRefs
  },
  SET_THEMES (state, themes) {
    state.themes = themes
  },
  SET_JOB_IDS (state, jobIds) {
    state.jobIds = jobIds
  },
  SET_COMPANY_INFO (state, companyInfo) {
    state.companyInfo = companyInfo
  }
}

const getters = {
  pagePathPrefix: (state) => {
    return state.pagePathPrefix
  },
  isEditMode: (state) => {
    return state.isEditMode
  },
  isPreview: (state) => {
    return state.isPreview
  },
  isMobile: (state) => {
    return state.isMobile
  },
  languageCode: (state) => {
    return state.languageCode
  },
  isEnLanguage: (state) => {
    return state.languageCode === 'en'
  },
  sitePages: (state) => {
    return state.sitePages
  },
  currentPage: (state) => {
    return state.currentPage
  },
  currentPageType: (state) => {
    return state.currentPageType
  },
  currentPageRenderData: (state) => {
    return state.currentPage && state.currentPage.renderData
  },
  currentPageModuleRefs: (state) => {
    return state.pageModuleRefs
  },
  themes: (state) => {
    return state.themes
  },
  jobIds: (state) => {
    return state.jobIds
  },
  companyInfo: (state) => {
    return state.companyInfo
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
